import lodashRange from 'lodash/range';

export const mapQuestionToSetting = (questions, assignmentQuestionSettings) =>
  questions.reduce((accum, question) => {
    const mapping = assignmentQuestionSettings
      .filter((config) => config.type === 9)
      .reduce((acc, setting) => {
        const settingQuestionReference = setting.qid.split(':')[0];
        const questionItemReference = question.learnosityItemReference;
        // remove periods when storing the key for correct field lookup when updating field
        const key = `${questionItemReference}:${question.title.replaceAll(
          '.',
          '',
        )}`;
        const prev = acc[key] || {};
        return settingQuestionReference === questionItemReference
          ? {
              ...acc,
              [key]: {
                ...prev,
                [`${setting.text}`]: {
                  ...setting,
                  essayLineHeight: 'NONE',
                },
              },
            }
          : acc;
      }, {});
    return {
      ...accum,
      ...mapping,
    };
  }, {});

export const truncate = (text) =>
  text.length > 120 ? `${text.substring(0, 120)}...` : text;

export const pagePercentOptions = (psMultipageFrqResponses = false) => {
  const firstPageOption = {
    label: psMultipageFrqResponses ? '0.125' : '12.5%',
    value: '12.5',
  };
  let pageOptionsList = [
    { label: '25%', value: '25' },
    { label: '50%', value: '50' },
    { label: '75%', value: '75' },
    { label: '100%', value: '100' },
  ];
  if (psMultipageFrqResponses) {
    pageOptionsList = lodashRange(0.25, 5.25, 0.25).map((item) => {
      const itemLabel = item.toFixed(2).toString().endsWith('5')
        ? item.toFixed(2)
        : item.toFixed(1);
      return { label: `${itemLabel}`, value: `${item * 100}` };
    });
  }
  return {
    options: [firstPageOption, ...pageOptionsList],
  };
};

export const QUESTION_LINED_OPTIONS = {
  options: [
    { label: 'on', value: 'STANDARD' },
    { label: 'off', value: 'NONE' },
  ],
};
